module.exports = __webpack_public_path__ + "img/userLogo16.528671f1.jpg";